import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { navLinks } from "../../mock";
import { useAuth } from "../../context/AuthContext";
import { SmartLink } from "../SmartLink";
import "./azhome.css";

const NAV = navLinks.filter((l) => !["Home", "Copy trading", "Education", "Questions"].includes(l.label))
  .map((l) => (l.label === "Markets" ? { ...l, href: "#az-markets" } : l));

// Dark, single-row header used only on the home page.
export const AzHeader = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { user, logout } = useAuth();
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 8);
    on(); window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  const close = () => setOpen(false);
  return (
    <header className={`az-header${scrolled ? " scrolled" : ""}${open ? " open" : ""}`} data-testid="az-header">
      <div className="az-wrap az-header-row">
        <Link to="/" className="az-logo" aria-label="Imperio Exchange home" data-testid="az-header-logo">
          <img src="/assets/imperio-logo.png" alt="Imperio Exchange" />
        </Link>
        <nav className="az-nav" aria-label="Main navigation">
          {NAV.map((l) => (
            <SmartLink key={l.label} href={l.href} onClick={close} data-testid={`az-nav-${l.label.toLowerCase().replace(/ /g, "-")}`}>{l.label}</SmartLink>
          ))}
        </nav>
        <div className="az-header-auth">
          {user ? (
            <>
              <Link to="/dashboard" className="az-hbtn az-hbtn-primary" onClick={close} data-testid="az-header-dashboard">Dashboard</Link>
              <button className="az-hbtn" onClick={() => { logout(); close(); }} data-testid="az-header-logout">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="az-hbtn" onClick={close} data-testid="az-header-login">Log in</Link>
              <Link to="/register" className="az-hbtn az-hbtn-primary" onClick={close} data-testid="az-header-signup">Sign Up</Link>
            </>
          )}
        </div>
        <button className="az-burger" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} onClick={() => setOpen(!open)} data-testid="az-header-menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </header>
  );
};
export default AzHeader;
